module.exports = __webpack_public_path__ + "static/media/logo_infinitum_vertical_branca.822507ab.png";